import React, { createContext, useEffect, useRef, useState } from 'react';
import { createStackNavigator, TransitionPresets } from '@react-navigation/stack';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useDispatch, useSelector } from 'react-redux';
import DoorKeyGuide from '../../Apps/doorKey/doorKeyGuide';
import DoorKey from '../../Apps/doorKey';
import OtpScreen from '../../Apps/doorKey/otpScreen';
import ChamberKey from '../../Apps/doorKey/chamberKey';
import { setGoHome, setShowLoginModal } from '../../Redux/Reducers/appConfigReducer';
import { calculateTimeDifference, generateToken, isWeb } from '../../utils/Helper';
import { getDigitalKeySupportedAuthMethods } from '../../Redux/Actions/doorKeyAction';
import ValidationOptions from '../../Apps/doorKey/validationOptions';
import { ASSAABLOY, CLICKED, DEMO_FLOW_ENABLED, DOOR_KEY_CATEGORY, DORMAKABA, EXIT, SALTO } from '../../config/Constant';
import { NativeModules } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { sendAnalytics } from '../../Redux/Actions/analyticsAction';
const { DormakabaPlugin, AssaAbloyPlugin, SaltoPlugin } = NativeModules;

const DoorKeyStack = createStackNavigator();
export const DOOR_KEY_GUIDE = 'DoorKeyGuide';
export const DOOR_KEY = 'DoorKey';
export const VALIDATION_OPTIONS = "ValidationOptions";
export const OTP_SCREEN = 'OtpVerification';
export const CHAMBER_KEY = 'ChamberKey';


export const DoorKeyContext = createContext();

export const DoorKeyNavigator = () => {

  const dispatch = useDispatch();
  const navigation = useNavigation();

  const [widgetLaunchTime, setWidgetLaunchTime] = useState(() => new Date());
  const [doorKeySessionID, setDoorKeySessionID] = useState(() => generateToken("doorkey_"));

  const { currentGuestDetails } = useSelector(state => state.guestDetailsSlice);
  let reservationNumber = currentGuestDetails?.reservationNumber
  let locationId = currentGuestDetails?.location

  const { isLoggedIn, doorKeyType } = useSelector((state) => state.appConfigSlice);

  const [initialRoute, setInitialRoute] = useState(null);
  let initializeFlow = useRef(false);
  

  useEffect(() => {

    const initDoorKeyFlow = () => {
      setInitialRoute(DOOR_KEY);
      initializeFlow.current = true;
      dispatch(sendAnalytics(DOOR_KEY_CATEGORY, CLICKED, {element: "widget", widgetSessionId: doorKeySessionID}));
    };


    // if demo flow enabled, start with door key flow
    if(DEMO_FLOW_ENABLED){
      if (!isLoggedIn) {
        dispatch(setShowLoginModal(true));
        dispatch(setGoHome(true));
        return;
      }

      initDoorKeyFlow();
      return;
    }

    // if web and demo flow disabled
    if(isWeb() && !DEMO_FLOW_ENABLED) {
      setInitialRoute(CHAMBER_KEY);
      return;
    }

    // if door key type is not set or not supported, redirect to chamber key
    if (!doorKeyType) {
      setInitialRoute(CHAMBER_KEY);
      return;
    }

    if (doorKeyType == ASSAABLOY) {
      if (!AssaAbloyPlugin) {
        setInitialRoute(CHAMBER_KEY);
        return;
      }
    }

    if (doorKeyType == DORMAKABA) {
      if (!DormakabaPlugin) {
        setInitialRoute(CHAMBER_KEY);
        return;
      }
    }

    if (doorKeyType == SALTO) {
      if (!SaltoPlugin) {
        setInitialRoute(CHAMBER_KEY);
        return;
      }
    }

    // if not logged in, show login modal and redirect to home
    if (!isLoggedIn) {
        dispatch(setShowLoginModal(true));
        dispatch(setGoHome(true));
        return;
    }

    initDoorKeyFlow();

    return () => {
      
      if(initializeFlow.current){
        const widgetCloseTime = new Date;
        const widgetCloseDuration = calculateTimeDifference(widgetLaunchTime, widgetCloseTime, 'second');
        dispatch(sendAnalytics(DOOR_KEY_CATEGORY, EXIT, { "element": "widget", "widgetSessionId": doorKeySessionID, "duration": widgetCloseDuration}));
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  if (initialRoute === null) {
    return null; // Or show a loading spinner or screen
  }

  return (
    <DoorKeyContext.Provider value={{ widgetSessionId: doorKeySessionID, widgetLaunchTime: widgetLaunchTime }}>
    <DoorKeyStack.Navigator screenOptions={{ headerShown: false, ...TransitionPresets.ModalFadeTransition }} initialRouteName={initialRoute}>
      <DoorKeyStack.Screen name={DOOR_KEY_GUIDE} component={DoorKeyGuide} />
      <DoorKeyStack.Screen name={DOOR_KEY} component={DoorKey} />
      <DoorKeyStack.Screen name={VALIDATION_OPTIONS} component={ValidationOptions} />
      <DoorKeyStack.Screen name={OTP_SCREEN} component={OtpScreen} options={{...TransitionPresets.SlideFromRightIOS}} />
      <DoorKeyStack.Screen name={CHAMBER_KEY}component={ChamberKey} />
    </DoorKeyStack.Navigator>
    </DoorKeyContext.Provider>
  );
};
